import React, { FC } from 'react'
import { Row } from 'antd'
import { __FormItem as FormItem } from './item'
import { IYhFormItemsBox, ISelectOption } from './Types'
import { useState } from 'react'
import FontIcon from '../YhIcon'
import { UpOutlined } from '@ant-design/icons'
import { YhBox } from '../YhBox'

export const __FormItemsBox: FC<IYhFormItemsBox> = ({ items, ...props }) => {
    const [isOpne, setIsopen] = useState(false)
    return <YhBox {...props}>
            <Row gutter={[40, 0]} justify="start">
                {items.map((el, index) => (
                    <FormItem
                        key={index}
                        {...el}
                        more={isOpne}
                        disable={el.disable ?? props.disabled}
                        copyText={(fieldName: string, option?: ISelectOption[]) => props?.copyText?.(fieldName, option as ISelectOption[])}
                    />
                ))}
            </Row>
        </YhBox>
}
